<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item>需求管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="showBtn==1">
        <el-button size="mini" type="primary" @click="showAddDemand(0)">创建需求</el-button>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="">
        <el-upload
          v-if="showBtn==1"
          class="upload-demo"
          :http-request="importDemand"
          action=""
          :show-file-list="false">
          <el-button size="mini" type="primary">导入需求</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="" v-if="showBtn==1">
        <el-button size="mini" type="primary" @click="downloadImportDemand">导入需求示例</el-button>
      </el-form-item>
      <el-form-item label="" v-if="showBtn==0">
        <el-button size="mini" type="primary" @click="exportDemand">导出</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部需求" name="all"></el-tab-pane>
      <el-tab-pane v-show="showBtn==1||showBtn==4||showBtn==0" label="待审核" name="1"></el-tab-pane>
      <el-tab-pane v-show="showBtn==1||showBtn==4||showBtn==0" label="采购员待确认" name="2"></el-tab-pane>
      <el-tab-pane v-show="showBtn==0" label="等待确认下单" name="4"></el-tab-pane>
      <el-tab-pane v-show="showBtn==3||showBtn==0" label="已下部分订单" name="5"></el-tab-pane>
      <el-tab-pane label="已下单" name="6"></el-tab-pane>
      <el-tab-pane label="不通过" name="3"></el-tab-pane>
    </el-tabs>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="sreachData.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setWeek">最近一周</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setMonth">最近一个月</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setThreeMonth">最近三个月</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="价格">
        <el-input v-model="sreachData.minMoney"></el-input>
        <!-- <el-input-number v-model="sreachData.minMoney" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number> -->
      </el-form-item>
      <span style="line-height:40px;margin:0 10px">-</span>
      <el-form-item label="">
        <el-input v-model="sreachData.maxMoney"></el-input>
        <!-- <el-input-number v-model="sreachData.maxMoney" controls-position="right" :precision="2" :step="0.1" :min="sreachData.minMoney"></el-input-number> -->
      </el-form-item>
      <el-form-item label="数量">
        <el-input-number v-model="sreachData.num" controls-position="right" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="需求来源" v-if="showBtn==3||showBtn<1||showBtn==2">
        <el-select v-model="sreachData.company" filterable clearable placeholder="请选择">
          <el-option label="全部" value="-1"></el-option>
          <el-option v-for="(val, key) in company" :key="key" :label="val.company" :value="val.id">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="状态">
        <el-select v-model="sreachData.status">
          <el-option label="全部需求" value="all"></el-option>
          <el-option v-show="showBtn==1||showBtn==4||showBtn==0" label="待审核" value="1"></el-option>
          <el-option v-show="showBtn==1||showBtn==4||showBtn==0" label="采购员待确认" value="2"></el-option>
          <el-option v-show="showBtn==0" label="等待确认下单" value="4"></el-option>
          <el-option v-show="showBtn==3||showBtn==0" label="已下部分订单" value="5"></el-option>
          <el-option label="已下单" value="6"></el-option>
          <el-option label="不通过" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="sreachData.words" placeholder="编码|名称|描述/规格|单位|备注" style="width:300px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="searchOrder">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      tooltip-effect="dark"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form v-for="(v,k) in props.row.supplier" :key="k" label-width="140px" label-position="right" inline>
              <el-form-item label="供应商">
                <span>{{ v.company }}</span>
              </el-form-item>
              <el-form-item label="数量">
                <span>{{ v.num }}</span>
              </el-form-item>
              <el-form-item label="价格">
                <span>{{ v.price }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      <el-table-column
        type="selection"
        width="45">
      </el-table-column>
      <el-table-column
        prop="id"
        width="50"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="gcode"
        width="100"
        label="物料编号">
      </el-table-column>
      <el-table-column
        prop="title"
        label="物料名称">
      </el-table-column>
      <el-table-column
        prop="remark"
        width="110"
        label="物料描述/规格">
        <template slot-scope="scope">
          <p class="slh" :title="scope.row.remark">{{scope.row.remark}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="total"
        width="100"
        label="总价">
      </el-table-column>
      <el-table-column
        prop="num"
        width="140"
        label="数量">
        <template slot-scope="scope">
          <p>总数量：{{scope.row.num}}</p>
          <p>下单数量：{{scope.row.costNum}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        width="130"
        label="单价（含税）">
        <template slot-scope="scope">
          <!-- <p v-if="scope.row.gprice!=scope.row.price" style="color:red">{{scope.row.price}}<br><em v-show="showBtn<1&&showBtn==3">(待询价)</em></p> -->
          <p>{{scope.row.price}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="unit"
        width="80"
        label="单位">
      </el-table-column>
      <el-table-column
        prop="deliveryTime"
        width="120"
        label="要求到货时间">
      </el-table-column>
      <el-table-column
        v-if="showBtn<1||showBtn==3"
        prop="company"
        width="110"
        label="需求来源">
      </el-table-column>
      <el-table-column
        prop="orderRemark"
        label="备注">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="140"
        label="下单时间">
      </el-table-column>
      <el-table-column
        prop="examineTime"
        width="110"
        label="审核时间">
      </el-table-column>
      <el-table-column
        prop="statusName"
        width="110"
        label="状态">
      </el-table-column>
      <el-table-column
        label="操作"
        width="360">
        <template slot-scope="scope">
          <el-upload
             style="float: left;"
            v-show="(showBtn<2||showBtn==3)&&!scope.row.file&&scope.row.status!=6"
            action=""
            :show-file-list="false"
            :http-request="newUploadfile"
            :before-upload="beforeUpload">
            <el-button @click="setid(scope.row.id)" size="mini" type="primary">上传文件</el-button>
          </el-upload>
          <el-button v-show="(showBtn<2||showBtn==3)&&scope.row.file&&scope.row.status!=6" size="mini" type="danger" plain @click="delfile(scope.row.id)">删除文件</el-button>
          <el-button v-show="scope.row.file" size="mini" type="info" plain @click="downfile(scope.row.file)">下载文件</el-button>
          <el-button v-show="scope.row.status==2&&showBtn==3&&scope.row.price<0.01&&(scope.row.priceExamine<1||scope.row.priceExamine==2)" size="mini" type="info" plain @click="goSetPrice(scope.row.catalogId)">申请价格</el-button>
          <!-- <el-button v-show="scope.row.status==2&&showBtn<1&&scope.row.price<0.01&&scope.row.priceExamine==1" size="mini" type="info" plain @click="showExaminePrice(scope.row.id)">审核价格</el-button>
          <el-button v-show="scope.row.status==2&&showBtn==3&&scope.row.price<0.01&&(scope.row.priceExamine<1||scope.row.priceExamine==2)" size="mini" type="info" plain @click="showSetPrice(scope.row.id)">申请价格</el-button> -->
          <el-button v-show="scope.row.status==1&&showBtn==4" size="mini" type="info" plain @click="examineDemand(scope.row.id,2)">审核通过</el-button>
          <el-button v-show="scope.row.status==1&&showBtn==4" size="mini" type="warning" plain @click="showeExamineDemand(scope.row.id)">审核不通过</el-button>
          <el-button v-show="scope.row.status==2&&showBtn==3&&scope.row.price>0" size="mini" type="warning" plain @click="showAddOrder(scope.row.id)">审核</el-button>
          <el-button v-show="scope.row.status==5&&showBtn==3&&scope.row.price>0" size="mini" type="warning" plain @click="showAddOrder(scope.row.id)">继续审核</el-button>
          <el-button v-show="(scope.row.status==4||scope.row.status==5)&&scope.row.count&&showBtn==0" size="mini" type="warning" plain @click="sureOrder(scope.row.id,1)">下单</el-button>
          <el-button v-show="(scope.row.status==4||scope.row.status==5)&&scope.row.count&&showBtn==0" size="mini" type="warning" plain @click="sureOrder(scope.row.id,2)">拒绝下单</el-button>
          <el-button v-show="(scope.row.status==4||scope.row.status==5)&&(showBtn==0||showBtn==3)&&scope.row.num!=scope.row.costNum" size="mini" type="warning" plain @click="showFinishDemand(scope.row.id,scope.row.count)">结束</el-button>
          <el-button v-show="scope.row.status==1&&scope.row.examine==2&&showBtn==1" size="mini" plain @click="showAddDemand(scope.row.id)">编辑</el-button>
          <el-button v-show="scope.row.status==3&&scope.row.examine==3&&showBtn==1" type="warning" size="mini" plain @click="showAddDemand(scope.row.id)">重新编辑</el-button>
          <el-button size="mini" type="success" plain @click="editOrder(scope.row.id)">详情</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delDemand(scope.row.id)" 
            title="确定删除订单吗？"
          >
            <el-button v-if="((scope.row.statusName=='待审核'||scope.row.statusName=='审核不通过')&&showBtn==1)||showBtn==0" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <p>
      <span style="float:left">
        <!-- <el-button @click="delDemand()">删除所选</el-button> -->
        <el-button type="primary" @click="showAddOrderAll()" v-if="this.sreachData.status==2&&showBtn==3">批量审核</el-button>
        <el-button type="primary" @click="examineDemandAll(0)" v-if="(activeName==1&&showBtn==4)||showBtn==0">审核通过</el-button>
      </span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
  <el-dialog title="结束需求" label-position="left" :visible.sync="finishDemandBox" width="70%">
    <el-form ref="form" :model="finishDemandForm" label-width="140px">
      <el-form-item label="备注">
        <el-input type="textarea" v-model="finishDemandForm.remark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="examineDemandBox = false">取 消</el-button>
      <el-button type="primary" @click="finishDemand()">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="审核不通过" label-position="left" :visible.sync="examineDemandBox" width="70%">
    <el-form ref="form" :model="examineDemandForm" label-width="140px">
      <el-form-item label="备注">
        <el-input type="textarea" v-model="examineDemandForm.remark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="finishDemandBox = false">取 消</el-button>
      <el-button type="primary" @click="examineDemand(examineDemandForm.id,3)">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="创建需求" label-position="left" :visible.sync="demandBox" width="70%">
    <el-form ref="form" :model="form" label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物料编号" :required="true">
            <!-- <el-input v-model="form.gcode" @change="getGoods()" autocomplete="off"></el-input> -->
            <el-autocomplete
            class="inline-input"
            v-model="form.gcode"
            :fetch-suggestions="querySearch"
            placeholder=""
            autocomplete="off"
            @select="getGoods()"
          ></el-autocomplete>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="客户物料编码">
            <el-input v-model="form.cgcode" @change="getGoods()" autocomplete="off"></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-form-item label="子公司" v-show="showBtn<1||showBtn==3" :required="true">
          <el-select v-model="form.companyid" placeholder="请选择">
            <el-option
              v-for="item in company"
              :key="item.id"
              :label="item.company"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="物料名称">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form :model="form" inline label-width="140px">
        <el-form-item label="单价（含税）">
          {{form.price}}
          <!-- <el-input-number v-model="form.price" :precision="2" :step="0.1" :min="0.00" :max="999999999"></el-input-number> -->
        </el-form-item>
        <el-form-item label="单位" :required="true">
          {{form.unit}}
          <!-- <el-input v-model="form.unit" autocomplete="off"></el-input> -->
        </el-form-item>
        <el-form-item label="申请数量" :required="true">
          <el-input-number v-model="form.num" :precision="2" :min="1" :max="999999999"></el-input-number>
        </el-form-item>
      </el-form>
      <el-form-item label="要求到货时间">
        <el-input v-model="form.deliveryTime" maxlength="60" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="物料描述/规格">
        <el-input type="textarea" v-model="form.remark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工厂" :required="true">
            <el-input v-model="form.factory" autocomplete="off" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购员">
            <!-- <el-input v-model="form.purchase" autocomplete="off" maxlength="100" show-word-limit></el-input> -->
            {{form.purchase}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="库位" :required="true">
        <el-input type="textarea" v-model="form.locator" maxlength="150" show-word-limit></el-input>
      </el-form-item>
      <!-- <el-form-item label="审核状态" v-if="showBtn==0||showBtn==4">
        <el-radio-group v-model="form.examine">
          <el-radio :label="0">待审核</el-radio>
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="2">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="说明附件" :required="true">
        <el-upload
          class="upload-demo"
          action=""
          :http-request="uploadFile"
          :on-remove="removeFile"
          :before-upload="beforeUpload"
          multiple
          :limit="1"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">上传的文件不能超过20M</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.orderRemark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="demandBox = false">取 消</el-button>
      <el-button type="primary" @click="createOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="需求下单" label-position="left" :visible.sync="orderBox" width="70%">
    <el-form ref="form" :model="orderForm" label-width="250px">
      <el-form-item label="审核状态">
        <el-radio-group v-model="orderForm.examine">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="2">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="需求数量">
        {{orderForm.num}}
      </el-form-item>
      <el-form-item label="已下单数量">
        {{orderForm.costNum}}
      </el-form-item>
      <el-row v-show="orderForm.examine==1">
        <el-form-item v-for="(v,k) in supplier" :key="k" :label="v.company" :required="true">
          <span>数量：</span><el-input-number v-model="v.num" :min="0"></el-input-number>
          <!-- <span>价格：</span><el-input-number v-model="v.price" :min="0" :precision="4"></el-input-number> -->
          <span>价格：{{v.price}}</span>
        </el-form-item>
      </el-row>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="orderForm.orderRemark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="orderBox = false">取 消</el-button>
      <el-button type="primary" @click="makeOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="批量需求下单" label-position="left" :visible.sync="orderBoxAll" width="70%">
    <el-form ref="form" :model="orderAllForm">
      <el-form-item label=" ">
        <el-table
          :data="orderAllForm.tableData"
          style="width: 100%">
          <el-table-column
            prop="title"
            label="物料名称"
            width="140">
          </el-table-column>
          <el-table-column
            prop="num"
            label="需求数量"
            width="140">
          </el-table-column>
          <el-table-column
            prop="costNum"
            label="已下单数量"
            width="140">
          </el-table-column>
          <el-table-column
            prop="orderRemark"
            label="备注"
            width="200">
          </el-table-column>
          <el-table-column
            prop="supplier"
            label="供应商">
            <template slot-scope="scope">
              <p v-if="scope.row.supplier.length>1" style="color: red;">此订单请单独审核</p>
              <div v-else>
                <el-row v-for="item in scope.row.supplier" :key="item.id">
                  <span>{{item.company}}</span>
                  <span style="color: chocolate;">数量:{{item.num}}</span>
                  <span style="color: red;">价格:{{item.price}}</span>
                </el-row>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="orderBoxAll = false">取 消</el-button>
      <el-button type="primary" @click="makeAllOrder">审核通过</el-button>
    </div>
  </el-dialog>
  <el-dialog title="申请价格" label-position="left" :visible.sync="setPriceBox" width="70%">
    <el-form ref="form" :model="setPriceForm" label-width="140px">
      <el-form-item label="价格">
        <el-input-number v-model="setPriceForm.price" :precision="4" :step="0.1" :max="100000"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="setPriceBox = false">取 消</el-button>
      <el-button type="primary" @click="setPrice()">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="审核价格" label-position="left" :visible.sync="examinePriceBox" width="70%">
    <el-form ref="form" :model="examinePriceForm" label-width="140px">
      <el-form-item label="审核">
        <el-radio-group v-model="examinePriceForm.status">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="examinePriceForm.remark">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="examinePriceBox = false">取 消</el-button>
      <el-button type="primary" @click="examinePrice()">确 定</el-button>
    </div>
  </el-dialog>
</el-card>
</template>
<script>
import fileFunction from "@/api/file"
import userFunction from "@/api/user"
import orderFunction from "@/api/order"
import goodsFunction from "@/api/goods"
export default {
  data() {
    return {
      demandid:0,
      showBtn:sessionStorage.getItem('roleid'),
      sendBox:false,
      setPriceBox:false,
      examinePriceBox:false,
      total:0,
      demandBox:false,
      orderBox:false,
      orderBoxAll:false,
      tableLoading:false,
      examineDemandBox:false,
      finishDemandBox:false,
      activeName:"all",
      level:[],
      Selectionids:[],
      fileList:[],
      log:[],
      supplier:[],
      company:[],
      sreachData:{
        page:1,
        limit:10,
        createTime:[],
        minMoney:'',
        maxMoney:'',
        company:'',
        status:'',
        words:'',
        num:'',
        vcode:sessionStorage.getItem('token'),
      },
      tableData:[],
      examineDemandForm:{
        id:'',
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      setPriceForm:{
        id:'',
        price:'',
        vcode:sessionStorage.getItem('token')
      },
      examinePriceForm:{
        id:'',
        status:2,
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      finishDemandForm:{
        id:'',
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      orderForm:{
        id:'',
        scale:'',
        examine:1,
        num:0,
        costNum:0,
        scaleData:[],
        orderRemark:'',
        vcode:sessionStorage.getItem('token')
      },
      orderAllForm:{
        tableData:[],
        orderRemark:'',
        vcode:sessionStorage.getItem('token')
      },
      form:{
        id:'',
        gcode:'',
        cgcode:'',
        companyid:'',
        title:'',
        unit:'',
        price:'',
        remark:'',
        deliveryTime:'',
        factory:'',
        purchase:'',
        file:'',
        locator:'',
        num:'',
        orderRemark:'',
        examine:0,
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    setid(id){
      this.demandid = id
      console.log(this.demandid)
    },
    querySearch(queryString, cb) {
      goodsFunction.Cataloglist({words:queryString,examine:1,vcode:sessionStorage.getItem('token')},this).then(res=>{
        var data = [];
        if(res.data.length>0){
          for(var i in res.data){
            data.push({value:res.data[i].gcode})
          }
        }
        cb(data);
      })
    },
    goSetPrice(catalogId){
      this.$router.push({path: '/home/goodsList',query: {catalogId: catalogId}})
    },
    beforeUpload(file){
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }
      return isLt20M;
    },
    removeFile() {
      this.form.file = '';
      this.fileList = [];
    },
    uploadFile(params){
      const file = params.file,form = new FormData();
      form.append("file", file)
      form.append("vcode", sessionStorage.getItem('token'));
      fileFunction.uploadFile(form,this).then(res=>{
        this.form.file=res.filename
        this.fileList.push({uid:res.filename,name:res.filename,url:res.filename})
      })
    },
    newUploadfile(params){
      const file = params.file,form = new FormData();
      let that = this
      form.append("file", file)
      form.append("vcode", sessionStorage.getItem('token'));
      fileFunction.uploadFile(form,that).then(res=>{
        orderFunction.setfile({vcode:sessionStorage.getItem('token'),file:res.filename,id:this.demandid},that).then(res=>{
          that.getList()
        })
      })
    },
    delfile(id){
      let that = this
      orderFunction.delfile({vcode:sessionStorage.getItem('token'),id:id},that).then(res=>{
        that.getList()
      })
    },
    importDemand(params){
      const file = params.file,form = new FormData();
      form.append("file", file)
      form.append("vcode", sessionStorage.getItem('token'));
      orderFunction.importDemand(form,this).then(res=>{
        this.getList()
      })
    },
    downloadImportDemand(){
      let a = document.createElement('a')
        a.href = '/upload/导入需求示例.xlsx'
        a.click()
    },
    exportDemand(){
      orderFunction.exportDemand(this.sreachData,this).then(res=>{
        let a = document.createElement('a')
        a.href = res.filepath
        a.click()
      })
    },
    downfile(file){
      let a = document.createElement('a')
        a.href = file
        a.click()
    },
    handleSizeChange(val){
      this.sreachData.limit = val
      this.getList()
    },
    handleCurrentChange(val){
      this.sreachData.page = val
      this.getList()
    },
    showAddOrderAll(){
      if(!this.Selectionids){
        return false;
      }
      orderFunction.getalldemand({ids:this.Selectionids,status:2,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.orderBoxAll = true
        this.orderAllForm.tableData = res.data
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showAddOrder(id){
      this.orderBox = true
      this.orderForm.scaleData = []
      this.orderForm.examine = 1
      this.orderForm.orderRemark = ''
      this.orderForm.id = id
      this.orderForm.num = 0
      this.getdemand()
      //this.getSupplier()
    },
    getdemand(){
      orderFunction.getdemand({id:this.orderForm.id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.orderForm.scaleData = []
        this.orderForm.scale = res.goods.scale
        this.orderForm.num = res.num
        this.orderForm.costNum = res.costNum
        this.orderForm.orderRemark = res.orderRemark
        for(var i in res.scaleArr){
          this.orderForm.scaleData.push({scale:res.scaleArr[i],value:parseInt(parseInt(res.num)*parseInt(res.scaleArr[i]) /100)})
        }
        this.getSupplier()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showExaminePrice(id){
      this.examinePriceBox = true
      this.examinePriceForm.id = id
      this.examinePriceForm.status = 2
      this.examinePriceForm.remark = ''
    },
    examinePrice(){
      orderFunction.examineDemandPrice(this.examinePriceForm,this).then(res=>{
        this.examinePriceBox = false
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showSetPrice(id){
      this.setPriceBox = true
      this.setPriceForm.id = id
      this.setPriceForm.price = ''
    },
    setPrice(){
      orderFunction.setDemandPrice(this.setPriceForm,this).then(res=>{
        this.setPriceBox = false
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showeExamineDemand(id){
      this.examineDemandBox = true
      this.examineDemandForm.id = id
      this.examineDemandForm.remark = ''
    },
    showAddDemand(id){
      this.demandBox = true
      if(id>0){
        orderFunction.getdemand({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
          this.form.id = res.id
          this.form.companyid = res.companyid
          this.form.gcode = res.gcode
          this.form.cgcode = res.cgcode
          this.form.title = res.title
          this.form.unit = res.unit
          this.form.deliveryTime = res.deliveryTime
          this.form.remark = res.remark
          this.form.price = res.price
          this.form.num = res.num
          this.form.orderRemark = res.orderRemark
          this.form.file = res.file
          this.form.examine = res.examine
          this.form.factory = res.factory
          this.form.purchase = res.purchase
          this.form.locator = res.locator
        })
      }else{
        this.form.id = ''
        this.form.companyid = ''
        this.form.gcode = ''
        this.form.cgcode = ''
        this.form.title = ''
        this.form.unit = ''
        this.form.remark = ''
        this.form.deliveryTime = ''
        this.form.file = ''
        this.form.price = 0.00
        this.form.num = ''
        this.form.orderRemark = ''
        this.form.examine = 0
        this.form.factory = sessionStorage.getItem('company') ? sessionStorage.getItem('company') :''
        this.form.purchase = ''
        this.form.locator = sessionStorage.getItem('address') ? sessionStorage.getItem('address') :''
      }
    },
    setWeek(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.sreachData.createTime = [start,end]
    },
    setMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.sreachData.createTime = [start,end]
    },
    setThreeMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.sreachData.createTime = [start,end]
    },
    getList(){
      orderFunction.demandlist(this.sreachData,this).then(res=>{
        this.tableData = res.data
        this.total = res.total
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    makeAllOrder(){
      orderFunction.makeAllOrder({ids:this.Selectionids,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
        this.orderBoxAll = false
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    makeOrder(){
      this.orderForm.scaleData = []
      var supplier = this.supplier,total = 0
      for(var i in supplier){
        total+=supplier[i].num
        this.orderForm.scaleData.push({id:supplier[i].id,gid:supplier[i].gid,companyid:supplier[i].companyid,price:supplier[i].price,scale:supplier[i].scale,num:supplier[i].num})
      }
      if(total>this.orderForm.num - this.orderForm.costNum){
        this.$message.error('下单数量不能大于总数')
        return false
      }
      orderFunction.makeOrder(this.orderForm,this).then(res=>{
        this.getList()
        this.orderBox = false
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    sureOrder(id,type){
      orderFunction.sureOrder({id:id,type:type,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    createOrder(){
      if(!this.form.gcode){
        this.$message.error('物料编号不能为空');
        return false;
      }
      if(!this.form.unit){
        this.$message.error('单位不能为空');
        return false;
      }
      if(!this.form.num){
        this.$message.error('申请数量不能为空');
        return false;
      }
      if(!this.form.factory){
        this.$message.error('工厂不能为空');
        return false;
      }
      if(!this.form.locator){
        this.$message.error('库位不能为空');
        return false;
      }
      orderFunction.saveDemand(this.form,this).then(res=>{
        this.demandBox = false
        this.form.companyid = ''
        this.form.gcode = ''
        this.form.cgcode = ''
        this.form.title = ''
        this.form.unit = ''
        this.form.remark = ''
        this.form.deliveryTime = ''
        this.form.price = 0.00
        this.form.num = ''
        this.form.orderRemark = ''
        this.form.examine = 0
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    editOrder(id){
      this.$router.push({path: '/home/editDemand',query: {id: id}})
    },
    delDemand(id){
      var delData = [];
      if(id){
        delData.push(id)
      }else{
        delData = this.Selectionids
      }
      orderFunction.delDemand({id:delData,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    examineDemandAll(id){
      var delData = [];
      if(id){
        delData.push(id)
      }else{
        delData = this.Selectionids
      }
      orderFunction.examineDemandAll({id:delData,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    searchOrder(){
      this.tableData = []
      this.getList()
    },
    handleClick(){
      this.sreachData.status = this.activeName;
      this.getList()
    },
    handleSelectionChange(val) {
      this.Selectionids = []
      for(var i in val){
        this.Selectionids.push(val[i].id);
      }
      
    },
    getGoods(){
      if(this.form.cgcode){
        goodsFunction.getGoods({cgcode:this.form.cgcode,vcode:sessionStorage.getItem('token')},this).then(res=>{
          if(!res||res.status!=1||res.examine!=1){
            this.$message.error('该物料已下架');
            return false;
          }
          this.form.gcode = res.gcode
          this.form.cgcode = res.cgcode
          this.form.title = res.title
          this.form.unit = res.unit
          this.form.remark = res.remark
          this.form.price = res.price
          this.form.purchase = res.purchase
          var oDate = new Date();
          var oDate1 = new Date(res.validity_start_time);
          var oDate2 = new Date(res.validity_end_time);
          if(oDate1.getTime() > oDate.getTime()||oDate2.getTime() < oDate.getTime()){
            this.priceMsg=true;
          }else{
            this.priceMsg=false;
          }
        }).catch(err=>{
          this.$message.error(err)
        })
      }else if(this.form.gcode){
        goodsFunction.getGoodsCatalog({gcode:this.form.gcode,vcode:sessionStorage.getItem('token')},this).then(res=>{
          if(!res||res.status!=1||res.examine!=1){
            this.$message.error('该物料已下架');
            return false;
          }
          this.form.gcode = res.gcode
          this.form.cgcode = res.cgcode
          this.form.title = res.title
          this.form.unit = res.unit
          this.form.remark = res.remark
          this.form.price = res.price
          this.form.purchase = res.purchase
          var oDate = new Date();
          var oDate1 = new Date(res.validity_start_time);
          var oDate2 = new Date(res.validity_end_time);
          if(oDate1.getTime() > oDate.getTime()||oDate2.getTime() < oDate.getTime()){
            this.priceMsg=true;
          }else{
            this.priceMsg=false;
          }
        }).catch(err=>{
          this.$message.error(err)
        })
      }
      
    },
    examineDemand(id,n){
      orderFunction.examineDemand({id:id,n:n,remark:this.examineDemandForm.remark,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
        this.examineDemandBox = false
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    finishOrder(id){
      orderFunction.finish({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showFinishDemand(id,count){
      if(count>0){
        this.$message.error('已下的订单还没收货完成')
        return false
      }
      this.finishDemandForm.id = id
      this.finishDemandForm.remark = ''
      this.finishDemandBox = true
    },
    finishDemand(){
      orderFunction.finishDemand(this.finishDemandForm,this).then(res=>{
        this.getList()
        this.finishDemandBox = false
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    getSupplier(){
      userFunction.getSupplier({demandid:this.orderForm.id,vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
        for(var i in this.supplier){
          this.supplier[i].num = parseFloat((this.orderForm.num-this.orderForm.costNum)*this.supplier[i].scale/100)
        }
      })
    },
    getCompany(){
      userFunction.getCompany({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.company = res
      })
    },
  },
  mounted () {
    this.getList()
    if(this.showBtn<1||this.showBtn==3){
      this.getCompany()
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/order/demandlist.vue